import React, { MouseEvent, useState } from 'react'
import {
    buildControlsExt,
} from '../../inputs/controls'
import { useFormValidation } from '../../../hooks/useFormValidation'
import { getCoreSettingsValidationSchema } from '../utils/getCoreSettingsValidationSchema'
import * as yup from 'yup'
import { useEffectAfterMount } from '../../../hooks/useEffectAfterMount'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import {
    modifyCoreSettings,
} from '../../../store/actions/coreSettingsActions'
import { getCoreSettingsControlDescriptors } from '../utils/getCoreSettingsControlDescriptors'
import { updateProductCoreSettings } from '../../../store/async-thunks/coreSettings/updateProductCoreSettings'

interface CoreSettingsFieldsProps {
    guid: string
    productCoreSettings: any
}

export const CoreSettingsFields = (props: CoreSettingsFieldsProps) => {
    const { guid, productCoreSettings } = props
    const dispatch = useAppDispatch()

    const [isSaveDisabled, setIsSaveDisabled] = useState(false)

    const coreSettingsValidationSchema = getCoreSettingsValidationSchema()

    const [state, setState, touched, setTouched, validationResult] =
        useFormValidation(productCoreSettings, coreSettingsValidationSchema)

    const checkSchema = yup.object().shape(coreSettingsValidationSchema)
    const isFromValid = checkSchema.isValidSync(state)

    const handleSave = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        setIsSaveDisabled(true)
        dispatch(updateProductCoreSettings({ guid, coreSettings: state }))
        setTimeout(() => setIsSaveDisabled(false), 3000)
    }

    const controlDescriptors = getCoreSettingsControlDescriptors(state)
    const dataArr = buildControlsExt(
        controlDescriptors,
        state,
        setState,
        touched,
        setTouched,
        validationResult
    )

    useEffectAfterMount(() => {
        dispatch(modifyCoreSettings({ guid, data: state }))
    }, [state])

    return (
        <div className="d-flex flex-column gap-3 p-4">
            {!!dataArr.length &&
                dataArr.map((el, i) => <div key={i}>{el}</div>)}
            <button
                type="button"
                onClick={handleSave}
                className="app-btn-main app-btn-apply fit-content mt-2"
                disabled={isSaveDisabled || !touched || !isFromValid}
            >
                Save
            </button>
        </div>
    )
}
